
import request from "./index";

export const appUser = {
  Get: (data) => {
    return request.post("/api/AppUser/List", data);
  },
  GetById: (id) => {
    return request.get(`/api/AppUser/GetAppUser/${id}`);
  },
  Create: (data) => {
    return request.post("/api/AppUser", data);
  },
  Update: (id, data) => {
    return request.put(`/api/AppUser/${id}`, data);
  },
  GetAgentList: (data) => {
    return request.post("/api/AppUser/GetAgentList", data);
  },
  SetAgentState: (data) => {
    return request.post("/api/AppUser/SetAgentState", data);
  },
  GetUserStateList: () => {
    return request.post("/api/AppUser/GetUserStateList");
  },
  GetAgentListByLoginUserCountry: () => {
    return request.post("/api/AppUser/GetAgentListByLoginUserCountry");
  },
  GetCountryListByLoginUser: (data) => {
    return request.post("/api/AppUser/GetCountryListByLoginUser", data);
  },
  GetASPListByLoginUser: () => {
    return request.post("/api/AppUser/GetASPListByLoginUser");
  },
  UploadAvatar: (data) => {
    return request.post("/api/AppUser/UploadAvatar", data);
  },
  GetRegionListByLoginUser: () => {
    return request.post("/api/AppUser/GetRegionListByLoginUser");
  },
};
